import { render, staticRenderFns } from "./list-view.vue?vue&type=template&id=9c1545c8&"
import script from "./list-view.vue?vue&type=script&lang=js&"
export * from "./list-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports